import React from "react";
import { getLocalDateString, parseLocalDate } from "@/lib/date";

function getTomorrow() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function getDayLabel(dateStr) {
  if (!dateStr || dateStr === "sin-fecha") return "Sin fecha";
  const today = getLocalDateString();
  const tomorrow = getTomorrow();
  if (dateStr === today) return "Hoy";
  if (dateStr === tomorrow) return "Mañana";
  const d = parseLocalDate(dateStr);
  if (!d) return dateStr;
  const dayName = d.toLocaleDateString("es-ES", { weekday: "long" });
  const dateLabel = d.toLocaleDateString("es-MX", { day: "numeric", month: "short" });
  return `${dayName.charAt(0).toUpperCase() + dayName.slice(1)}, ${dateLabel}`;
}

export default function AgendaDayGroup({ date, count, children }) {
  const label = getDayLabel(date);
  const isToday = date === getLocalDateString();

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <span className={`text-[11px] font-bold uppercase tracking-wider ${isToday ? "text-brand" : "text-slate-400 dark:text-slate-500"}`}>
          {label}
        </span>
        {isToday && (
          <span className="h-1.5 w-1.5 rounded-full bg-brand shrink-0" />
        )}
        <div className="flex-1 h-px bg-slate-200/80 dark:bg-slate-700/50" />
      </div>
      <div className="space-y-2">{children}</div>
    </div>
  );
}
